import { render } from "./SliderEditorCmp.vue?vue&type=template&id=28c9fb94"
import script from "./SliderEditorCmp.vue?vue&type=script&lang=js"
export * from "./SliderEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__